module.exports = __webpack_public_path__ + "media/Video 114.2aac22e9.mp4";